// config.js — leaf configuration module (no imports → no cycles, no races).
//
// API_BASE lives here, not in App.js, so that auth.js (and anything else that
// runs before React mounts providers) can import it directly. The previous
// design injected the base into auth.js at AuthProvider-mount time — but React
// runs CHILD effects before PARENT effects, so MainApp's boot data loads hit
// authFetch → refreshTokens before initAuth(apiBase) ever ran, producing the
// literal URL "null/auth/refresh" (relative → resolved against the dev server,
// 404) and killing the session on every hard refresh.
//
// The base comes from REACT_APP_API_BASE — the same shape as the control
// center's VITE_API_BASE. CRA BAKES `process.env.REACT_APP_*` INTO THE BUNDLE
// AT BUILD TIME: changing the variable on a running host does nothing, so test
// and prod each need their OWN build (`REACT_APP_API_BASE=… npm run build`).
// config.test.js fails if any other module hardcodes a host.
//
// THERE IS NO PRODUCTION FALLBACK, and that is the correction (2026-09-17).
// This line used to end with a hardcoded production host and the note "unset
// keeps today's production host, so nothing breaks". True when written; false
// now — that host is a tunnel to a laptop and answers 502. An unset
// variable therefore stopped meaning "keep working" and started meaning "load
// normally and fail every call against a dead host", which is the worst
// available failure: invisible until a user tries to do something.
//
// A build without the variable is now REFUSED by scripts/check-api-base.js,
// wired as npm's `prebuild`. It has to be a build-time script rather than a
// throw here: webpack bundles this module, it never runs it, so a throw would
// reach the browser as a white screen on an already-published bundle.
//
// The dev default below is deliberate and is NOT a fallback in the old sense:
// 127.0.0.1:8000 is what docker-compose publishes, it is wrong only on the
// machine of the one developer who would see it fail immediately, and it
// cannot be published — a production build without the variable never gets
// past prebuild.

const DEV_FALLBACK = 'http://127.0.0.1:8000';

const RAW_BASE = process.env.REACT_APP_API_BASE || DEV_FALLBACK;

/** No trailing slash, ever — every call site builds `${API_BASE}/path`. */
export const API_BASE = RAW_BASE.replace(/\/+$/, '');
